module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot4-f3ee9b4530bc8090a33ae48b6c3ff7ca.png";